<template>
  <LoadingSpinner v-if="loadingPage" />
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 border-bottom">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-12">
                <h6>
                  <b>{{ arrendamiento.nombre }} </b>
                </h6>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <TablaInteresesTipo
                :interesesAzul="interesesAzul"
                :interesesPlatino="interesesPlatino"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingComponent";
import TablaInteresesTipo from "./components/TablaInteresesTipo";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      arrendamiento_id: this.$route.params.arrendamiento_id,
    };
  },
  components: {
    LoadingSpinner,
    TablaInteresesTipo,
  },
  computed: {
    ...mapState("intereses", [
      "arrendamiento",
      "interesesAzul",
      "interesesPlatino",
      "loadingPage",
    ]),
  },
  methods: {
    ...mapActions("intereses", ["fetchInteresesByArrendamiento"]),
  },
  mounted() {
    this.fetchInteresesByArrendamiento(this.arrendamiento_id);
  },
};
</script>
